module.exports = __webpack_public_path__ + "media/application/assets/footer-3e8ea8b7400a215fc617ca1e62bae7e2.png";